import Checkbox from "@mui/material/Checkbox";
import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormHelperText from "@mui/material/FormHelperText";
import Typography from "@mui/material/Typography";
import { Controller } from "react-hook-form";

const MpgCheckbox = ({
  rhfFormInstance,
  disabled,
  label,
  name,
  required,
  sx,
  onChangeExtraHandler,
  labelStyleSx,
  defaultChecked,
  persistantMsg
}) => {
  const { control, setValue } = rhfFormInstance;

  const myStyle = {
    // '& .MuiInputBase-root.Mui-disabled': {
    //   backgroundColor: '#f5f5f5',
    // },
  };

  const myLabelStyle = {
    color: "#8991a0",
  };

  return (
    <Controller
      control={control}
      name={name}
      render={({
        field: field,
        fieldState: { invalid, isTouched, isDirty, error },
        formState: { errors },
      }) => {
        // console.log("checked:", field.value);
        return (
          <FormControl required={required} error={!!error} variant="outlined">
            <FormControlLabel
              control={
                <Checkbox
                  id={`${name}-mpg-checkbox`}
                  {...field}
                  disabled={!!disabled}
                  name={field.name}
                  sx={[myStyle, sx]}
                  inputProps={{ "aria-label": "controlled" }}
                  checked={!!defaultChecked ? defaultChecked : field.value}
                  onChange={(e) => {
                    field.onChange(e.target.checked)

                    if (!!onChangeExtraHandler) {
                      onChangeExtraHandler(e)
                    }
                  }}
                />
                /**IMP note: both checked and  defaultChecked props can not be used together. we use checked prop. we r passing default values to checked prop (if defaultChecked is passed by user). if we use both it throws controlled and uncontrolled comp error in react*/
                // defaultChecked
              }
              label={
                <Typography sx={[myLabelStyle, labelStyleSx]}>
                  {label}
                </Typography>
              }
            />
            <FormHelperText>{!!error && error.message}</FormHelperText>
            {
              !!persistantMsg ? (
                <p>{persistantMsg}</p>
              ) : ""
            }

          </FormControl>
        );
      }}
    />
  );
};
export default MpgCheckbox;
